var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":"wizard-teste-window"}},[_c('Wizard',{attrs:{"tipo":_vm.novoTipo,"item":_vm.novoItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }